/**
 * Desktop global nav open/close — Vermicular-style clip-path panel.
 * Syncs overlay + navigationBg height with theme hover (.is-action__hover).
 */
(function () {
	var MQ = window.matchMedia('(min-width: 1025px)');
	var root = null;
	var navBg = null;
	var cover = null;
	var observer = null;
	var resizeObs = null;
	var items = [];
	var activeLi = null;

	function qs(sel, ctx) {
		return (ctx || document).querySelector(sel);
	}

	function qsa(sel, ctx) {
		return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
	}

	function headerHeight() {
		var bar = qs('[data-header-height]', root);
		return bar ? bar.offsetHeight : 70;
	}

	function subMenuOf(li) {
		for (var i = 0; i < li.children.length; i++) {
			if (li.children[i].classList.contains('t4s-sub-menu')) return li.children[i];
		}
		return null;
	}

	function setOpen(open, height) {
		if (!root) return;
		root.classList.toggle('is-c-header-nav-open', open);
		document.documentElement.classList.toggle('is-c-header-nav-open', open);
		if (navBg && open && height) {
			navBg.style.setProperty('--c-header-nav-h', height + 'px');
		}
		if (cover) cover.setAttribute('aria-hidden', open ? 'false' : 'true');
		if (navBg) navBg.setAttribute('aria-hidden', open ? 'false' : 'true');
	}

	function measureAndOpen(li) {
		activeLi = li;
		var sub = subMenuOf(li);
		/* clip-path / opacity do not collapse layout box */
		var h = headerHeight() + (sub && sub.offsetHeight ? sub.offsetHeight : 200);
		setOpen(true, Math.max(h, headerHeight() + 120));
		if (resizeObs) {
			resizeObs.disconnect();
			if (sub) resizeObs.observe(sub);
		}
	}

	function syncFromDom() {
		if (!MQ.matches) {
			activeLi = null;
			setOpen(false);
			return;
		}
		var active = null;
		for (var i = 0; i < items.length; i++) {
			if (items[i].classList.contains('is-action__hover')) {
				active = items[i];
				break;
			}
		}
		if (active) measureAndOpen(active);
		else {
			activeLi = null;
			if (resizeObs) resizeObs.disconnect();
			setOpen(false);
		}
	}

	function bind() {
		root = qs('.t4s-section-header') || qs('#shopify-section-header-inline');
		if (!root) return;
		navBg = qs('[data-c-header-nav-bg]', root) || qs('[data-c-header-nav-bg]');
		cover = qs('[data-c-header-cover]', root) || qs('[data-c-header-cover]');
		items = qsa('.t4s-nav__ul > .t4s-menu-item.has--children', root);

		if (observer) observer.disconnect();
		if (resizeObs) resizeObs.disconnect();
		observer = new MutationObserver(syncFromDom);
		if (typeof ResizeObserver !== 'undefined') {
			resizeObs = new ResizeObserver(function () {
				if (activeLi && MQ.matches) measureAndOpen(activeLi);
			});
		}
		items.forEach(function (li) {
			observer.observe(li, { attributes: true, attributeFilter: ['class'] });
			li.addEventListener('mouseenter', function () {
				if (MQ.matches) measureAndOpen(li);
			});
			li.addEventListener('mouseleave', function () {
				if (!MQ.matches) return;
				requestAnimationFrame(syncFromDom);
			});
		});
		syncFromDom();
	}

	function onReady(fn) {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
		else fn();
	}

	onReady(bind);
	if (MQ.addEventListener) MQ.addEventListener('change', bind);
	else if (MQ.addListener) MQ.addListener(bind);
	document.addEventListener('shopify:section:load', bind);
})();
